import { Component, Input } from '@angular/core';
import { MatTooltipModule } from '@angular/material/tooltip';

@Component({
  selector: 'app-alert',
  standalone: true,
  imports: [MatTooltipModule],
  templateUrl: './alert.component.html',
  styleUrls: ['./alert.component.sass'],
})
export class AlertComponent {
  @Input() tooltip!: string;
  @Input() text!: string;
}
